<div>
        <!-- <div class = "d-flex justify-content-between">
            <h2 mat-dialog-title class="margin-0 mar-l-0 pd-t-5px">Follow-up Meeting </h2>
            <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <mat-divider class="mat-divider"></mat-divider> -->
        <div mat-dialog-content class="row content-container">
            <form [formGroup]="followUp" class="p-0">
                <div class="row">
                    <mat-form-field class="para-container input-field-formatting body-font-size">
                        <mat-label class="body-font-size">Meeting Title</mat-label>
                        <input formControlName="meetingTitle" class="body-font-size" type="text"   matInput placeholder="Meeting Title"  name="name">
                        <input formControlName="meetingDateStr" class="body-font-size" type="hidden" id="meetingDateStr" />
                    </mat-form-field>
                </div>
                <div class="d-flex col-md-12 justify-content-between flex-wrap p-0">
                    <!-- <div class="col-md-6"> -->
                        <mat-form-field class="col-md-5 para-container input-field-formatting body-font-size">
                            <mat-label class="body-font-size">Meeting Date</mat-label>
                            <input formControlName="meetingDate" placeholder="Meeting Date"  class="due-Date editable-assignedTo body-font-size" #input type="text" [matDatepicker]="picker" (focus)="picker.open()"  (dateInput)="assignMeetingDate($event)"  readonly matInput >
                            <!-- <input #input [formControl]="meetingDate" class="body-font-size" type="text"  [matDatepicker]="picker" (focus)="picker.open()"  readonly matInput placeholder="Meeting Date"> -->
                            <mat-datepicker  (closed)="input.blur()" #picker></mat-datepicker>
                        </mat-form-field>
                    <!-- </div> -->
                    <!-- <div class="col-md-6"> -->
                        <mat-form-field class="col-md-5 para-container input-field-formatting body-font-size">
                            <mat-label class="body-font-size">Meeting Time</mat-label>
                            <input formControlName="meetingStartTime" mask="Hh:m0" [dropSpecialCharacters]="false"  class="body-font-size" type="text" matInput placeholder="Meeting Time"  name="name"  >
                        </mat-form-field>
                    <!-- </div> -->
                </div>  
                <div class="row">
                    <mat-form-field class="para-container body-font-size">
                        <mat-label class="body-font-size">Location</mat-label>
                        <textarea formControlName="location" class="body-font-size" [ngStyle]="{'height':'20px'}" type="text"  matInput></textarea>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-radio-group [(ngModel)]= "selectedParticipant" [formControl]="participants" [disabled]="disableUser">
                        <mat-radio-button [value]="1" class="body-font-size rdo-btn1">Include All Participant(s)</mat-radio-button>
                        <mat-radio-button [value]="2"  class="body-font-size">Include Selected Participant(s)</mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf= "selectedParticipant == '2'" class="body-font-size">
                        <!-- selected participant -->
                        <mat-form-field [ngStyle]="{'width':'95%', 'padding-top':'1.25rem', 'margin-left':'1.75rem'}">
                            <mat-label>Selected Participants</mat-label>
                            <mat-select disableOptionCentering panelClass="common-drop-down-class" [formControl]="participantControl" multiple (blur) = "attendeeTrigger($event)">
                          
                              <mat-select-trigger>
                                <mat-chip-listbox>
                                  <mat-chip-option *ngFor="let attChip of participantControl.value"
                                    [removable]="true" (removed)="onAttendeeRemoved(attChip)">
                                    {{ attChip.attendeeName }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                  </mat-chip-option>
                                </mat-chip-listbox>
                              </mat-select-trigger>
                          
                              <!-- <mat-option *ngFor="let topping of toppingList" [value]="topping">{{topping}}</mat-option> -->
                              <ng-container *ngFor="let attObj of attendeeList">
                                <mat-option *ngIf="isValidAttendee(attObj)" [value]="attObj">{{attObj.attendeeName}}</mat-option>
                            </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <mat-radio-group [(ngModel)]= "selectedAgenda" [formControl]="agenda">
                        <mat-radio-button [value]="1" class="body-font-size rdo-btn2">Include All Agenda(s)</mat-radio-button>
                        <mat-radio-button [value]="2" class="body-font-size">Include Selected Agenda(s)</mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf= "selectedAgenda == '2' " class="body-font-size">
                        <!-- selected agenda -->
                        <mat-form-field [ngStyle]="{'width':'95%', 'padding-top':'1.25rem', 'margin-left':'1.75rem'}">
                            <mat-label>Selected Agenda</mat-label>
                            <mat-select disableOptionCentering panelClass="common-drop-down-class" class = "select-panel" [formControl]="agendaControl" multiple (blur) = "agendaTrigger()">
                          
                              <mat-select-trigger>
                                <mat-chip-listbox>
                                  <mat-chip-option *ngFor="let agendaObj of agendaControl.value"
                                    [removable]="true" (removed)="onAgendaRemoved(agendaObj)">
                                    {{ agendaObj.agendaTitle }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                  </mat-chip-option>
                                </mat-chip-listbox>
                              </mat-select-trigger>
                              <ng-container *ngFor="let agObj of agendaList">
                                <mat-option *ngIf="isValidAgenda(agObj)" [value]="agObj">{{agObj.agendaTitle}}</mat-option>
                            </ng-container>
                              <!-- <mat-option *ngFor="let topping of agendaList" [value]="topping">{{topping}}</mat-option> -->
                          
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </form>
            
        </div>
        
        <!-- <div mat-dialog-content > -->
                

                <!-- <mat-form-field class="input-container meetingType">
                    <mat-label class="label-font body-font-size">Meeting Type</mat-label>
                    <mat-select [formControl]="meetingType" class="body-font-size">
                        <ng-container *ngIf="meetingTypeField.length">
                            <mat-option class="body-font-size"
                                *ngFor="let m of meetingTypeField" [value]="m.codeId">{{m.description}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>  -->

        <!-- </div> -->
        
    
        <div class="d-flex justify-content-end" mat-dialog-actions>
            <!-- <span><button class="button-container primary" type="button" mat-flat-button color="primary">Save</button></span>&nbsp;&nbsp;
            <span> -->
                <button class="button-container primary" type="button" mat-flat-button color="primary" (click) = "saveAsFollowupMeeting('Y')">
                    SCHEDULE
                </button>
                <button class="button-container primary" type="button" mat-flat-button color="primary" (click) = "saveAsFollowupMeeting('N')">
                    SAVE
                </button>
                
                <button type="button" #editModalClose mat-flat-button color="primary" class="button-container primary" (click)="closeDialog()">
                    CANCEL
                </button>
            <!-- </span> -->
        </div>
    </div>
